import { Utils } from '../utils';
import httpClient from '../utils/httpClient';

const mountAttendanceBody = (attendanceData) => {
	const body = {
		channel: attendanceData.channel || 'SCHEDULER_V2',
		event_id: attendanceData.event_id,
		user_id: attendanceData.user_id,
		patient_id: attendanceData.patient_id,
		place_id: attendanceData.place_id,
		start_date: attendanceData.start_date
	};

	if (attendanceData.end_date != null) {
		body.end_date = attendanceData.end_date;
	}

	if (attendanceData.insurance_id != null) {
		body.insurance_id = attendanceData.insurance_id;
	}

	if (attendanceData.insurance_number != null && attendanceData.insurance_number !== '') {
		body.insurance_number = attendanceData.insurance_number;
	}

	if (attendanceData.insurance_card_file_id != null) {
		body.insurance_card_file_id = attendanceData.insurance_card_file_id;
	}

	if (attendanceData.files_ids?.length) {
		body.files_ids = attendanceData.files_ids;
	}

	if (attendanceData.schedule_link_code) {
		body.schedule_link_code = attendanceData.schedule_link_code;
	}

	return body;
};

export const createAttendance = async (attendanceData) => {
	const body = mountAttendanceBody(attendanceData);

	return httpClient({
		method: 'post',
		url: '/attendances',
		data: body,
		headers: {
			authorization: Utils.getAuthToken()
		}
	});
};

export const findAttendanceByToken = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: '/attendances/find-by-token',
		headers: {
			authorization: `Bearer ${filter.token}`
		}
	});

	return { data, error };
};

export const updateAttendance = async attendanceData => {
	const { data, error } = await httpClient({
		method: 'put',
		url: '/attendances',
		data: attendanceData,
		headers: {
			authorization: `Bearer ${attendanceData.token}`
		}
	});

	return { data, error };
};

export const cancelAttendance = async attendanceData => {
	const { data, error } = await httpClient({
		method: 'put',
		url: `/attendances/cancel`,
		headers: {
			authorization: `Bearer ${attendanceData.token}`
		}
	});

	return { data, error };
};

export const findEvaluationByToken = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: '/attendances/evaluation',
		headers: {
			authorization: `Bearer ${filter.token}`
		}
	});

	return { data, error };
};

export const submitEvaluation = async payload => {
	const { data, error } = await httpClient({
		method: 'post',
		url: '/attendances/evaluation',
		data: payload,
		headers: {
			authorization: `Bearer ${payload.token}`
		}
	});

	return { data, error };
};

export const findRescheduleByToken = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: '/attendances/reschedule',
		headers: {
			authorization: `Bearer ${filter.token}`
		}
	});

	return { data, error };
};
